module.exports = __webpack_public_path__ + "img/daño.2751540b.svg";